<template>
    <DrawRegionNaverMap />
</template>

<script>
import { mapGetters } from "vuex";
// import naverMapMixins from '@/stores/naver.map.mixin';
import DrawRegionNaverMap from '@/components/DrawRegionNaverMap.vue';

export default {
    components: {
        DrawRegionNaverMap,
    },
    computed: {
    },
    created() {},
    // mixins: [naverMapMixins],
};
</script>
